module.exports = __webpack_public_path__ + "static/media/PM9.b263eb1a.png";